import { IconChevronLeft } from "@tabler/icons-react";
import type { FC } from "react";
import { Button as AriaButton } from "react-aria-components";

/** Displays the expand/collapse chevron button */
export const ChapterItemChevronButton: FC = () => {
  return (
    <AriaButton slot="chevron">
      <IconChevronLeft className="size-5 text-slate-400 transition-transform group-aria-expanded:-rotate-90" />
    </AriaButton>
  );
};
